<template>
  <section
    id="comparison-school"
    class="co-bg-striped px-4 py-20"
  >
    <div class="co-container-lg mx-auto">
      <h2 class="co-heading-2-caption">
        他スクールとの比較
      </h2>
      <h3 class="co-display-12 mb-[3.25rem] text-center leading-base">
        他のスクールと比較するとテックアカデミーの<br class="hidden md:block">コストパフォーマンスの高さをご確認いただけます。
      </h3>
      <div class="overflow-x-auto">
        <table class="te-comparison-school-table table text-center">
          <thead>
            <tr class="hidden h-auto lg:table-row lg:h-[100px]">
              <th
                class="table border-t-0"
              />
              <th
                class="w-[33%] border-8 border-b-0 border-co-primary-500 bg-co-primary-500 align-middle"
              >
                <img
                  class="mx-auto"
                  src="~/assets/images/Te/TeCommon/Logo/logo.png"
                  alt="テックアカデミー"
                  width="272"
                  height="35"
                >
              </th>
              <th
                class="w-[22%] border-r bg-co-gray-400 align-middle text-white"
              >
                A社
              </th>
              <th
                class="w-[22%] border-r bg-co-gray-400 align-middle text-white"
              >
                B社
              </th>
            </tr>
          </thead>
          <tbody class="bg-white">
            <tr class="te-comparison-tr h-auto lg:h-[100px]">
              <th class="flex border align-middle lg:table-cell">
                <span class="te-school-heading">
                  講師
                </span>
              </th>
              <td class="te-comparison-td flex border-8 border-y-0 border-co-primary-500 align-middle lg:table-cell">
                <span class="te-school-col block basis-5/12 bg-co-primary-500 text-white lg:hidden lg:basis-auto">
                  <img
                    class="mx-auto inline w-full"
                    src="~/assets/images/Te/TeCommon/Logo/logo.png"
                    alt="テックアカデミー"
                    style="max-width: 138px"
                  >
                </span>
                <span class="te-school-col co-display-11 block basis-7/12 text-co-primary-500 lg:basis-full">
                  選考を通過した
                  <br>
                  <slot name="mentor">
                    現役エンジニア
                  </slot>
                </span>
              </td>
              <td class="flex border align-middle lg:table-cell">
                <span class="te-school-col te-school-gray block basis-5/12 lg:hidden lg:basis-auto">
                  A社
                </span>
                <span class="te-school-col block basis-7/12 lg:basis-auto">
                  大学生や卒業生が中心
                </span>
              </td>
              <td class="flex border align-middle lg:table-cell">
                <span class="te-school-col te-school-gray block basis-5/12 lg:hidden lg:basis-auto">
                  B社
                </span>
                <span class="te-school-col block basis-7/12 lg:basis-auto">
                  <slot name="teacher">
                    エンジニア
                  </slot>
                  ではない
                  <br>
                  スクールの専任講師
                </span>
              </td>
            </tr>
            <tr class="te-comparison-tr h-auto border lg:h-[100px]">
              <th class="flex border align-middle lg:table-cell">
                <span class="te-school-heading">
                  パーソナルメンター
                </span>
              </th>
              <td class="te-comparison-td flex border-8 border-y-0 border-co-primary-500 align-middle lg:table-cell">
                <span class="te-school-col block basis-5/12 bg-co-primary-500 text-white lg:hidden lg:basis-auto">
                  <img
                    class="mx-auto inline w-full"
                    src="~/assets/images/Te/TeCommon/Logo/logo.png"
                    alt="テックアカデミー"
                    style="max-width: 138px"
                  >
                </span>
                <span class="te-school-col co-display-11 block basis-7/12 text-co-primary-500 lg:basis-auto">
                  全員が
                  <br>
                  <slot name="mentor">
                    現役エンジニア
                  </slot>
                </span>
              </td>
              <td class="flex border align-middle lg:table-cell">
                <span class="te-school-col te-school-gray block basis-5/12 lg:hidden lg:basis-auto">
                  A社
                </span>
                <span class="te-school-col block basis-7/12 lg:basis-auto">
                  <slot name="teacher">
                    エンジニア
                  </slot>
                  ではない
                  <br>
                  担当者が対応
                </span>
              </td>
              <td class="flex border align-middle lg:table-cell">
                <span class="te-school-col te-school-gray block basis-5/12 lg:hidden lg:basis-auto">
                  B社
                </span>
                <span class="te-school-col basis-7/12 lg:basis-auto">
                  <FontAwesomeIcon
                    :icon="faXmark"
                    class="fa-fw inline size-4"
                  />
                </span>
              </td>
            </tr>
            <tr class="te-comparison-tr h-auto lg:h-[100px]">
              <th class="flex border align-middle lg:table-cell">
                <span class="te-school-heading">
                  受講形態
                </span>
              </th>
              <td class="te-comparison-td flex border-8 border-y-0 border-co-primary-500 align-middle lg:table-cell">
                <span class="te-school-col block basis-5/12 bg-co-primary-500 text-white lg:hidden lg:basis-auto">
                  <img
                    class="mx-auto inline w-full"
                    src="~/assets/images/Te/TeCommon/Logo/logo.png"
                    alt="テックアカデミー"
                    style="max-width: 138px"
                  >
                </span>
                <span class="te-school-col co-display-11 basis-7/12 text-co-primary-500 lg:basis-auto">
                  オンライン完結
                </span>
              </td>
              <td class="flex border align-middle lg:table-cell">
                <span class="te-school-col te-school-gray block basis-5/12 lg:hidden lg:basis-auto">
                  A社
                </span>
                <span class="te-school-col block basis-7/12 lg:basis-auto">
                  教室とオンライン
                </span>
              </td>
              <td class="flex border align-middle lg:table-cell">
                <span class="te-school-col te-school-gray block basis-5/12 lg:hidden lg:basis-auto">
                  B社
                </span>
                <span class="te-school-col block basis-7/12 lg:basis-auto">
                  教室とオンライン
                </span>
              </td>
            </tr>
            <tr
              v-if="benefits"
              class="te-comparison-tr h-auto border lg:h-[100px]"
            >
              <th class="flex border align-middle lg:table-cell">
                <span class="te-school-heading">
                  給付金対象
                </span>
              </th>
              <td class="te-comparison-td flex border-8 border-y-0 border-co-primary-500 align-middle lg:table-cell">
                <span class="te-school-col block basis-5/12 bg-co-primary-500 text-white lg:hidden lg:basis-auto">
                  <img
                    class="mx-auto inline w-full"
                    src="~/assets/images/Te/TeCommon/Logo/logo.png"
                    alt="テックアカデミー"
                    style="max-width: 138px"
                  >
                </span>
                <span class="te-school-col co-display-11 basis-7/12 p-0 text-co-primary-500 lg:basis-auto">
                  <FontAwesomeIcon
                    :icon="faCircle"
                    class="fa-fw inline size-4"
                  />
                  <br>
                  対象
                  <br>
                  最大56万円以上還元
                </span>
              </td>
              <td class="flex border align-middle lg:table-cell">
                <span class="te-school-gray block basis-5/12 lg:hidden lg:basis-auto">
                  A社
                </span>
                <span class="te-school-col block basis-7/12 lg:basis-auto">
                  <FontAwesomeIcon
                    :icon="faXmark"
                    class="fa-fw inline size-4"
                  />
                  <br>
                  対象外
                </span>
              </td>
              <td class="flex border align-middle lg:table-cell">
                <span class="te-school-col te-school-gray block basis-5/12 lg:hidden lg:basis-auto">
                  B社
                </span>
                <span class="te-school-col block basis-7/12 lg:basis-auto">
                  <FontAwesomeIcon
                    :icon="faXmark"
                    class="fa-fw inline size-4"
                  />
                  <br>
                  対象外
                </span>
              </td>
            </tr>
            <tr class="te-comparison-tr h-auto lg:h-[100px]">
              <th class="block border align-middle lg:table-cell">
                <span>
                  マンツーマンレッスン
                  <br>
                  （メンタリング）
                </span>
              </th>
              <td class="te-comparison-td flex border-8 border-y-0 border-co-primary-500 align-middle lg:table-cell">
                <span class="te-school-col block basis-5/12 bg-co-primary-500 text-white lg:hidden lg:basis-auto">
                  <img
                    class="mx-auto inline w-full"
                    src="~/assets/images/Te/TeCommon/Logo/logo.png"
                    alt="テックアカデミー"
                    style="max-width: 138px"
                  >
                </span>
                <span class="te-school-col co-display-11 basis-7/12 text-co-primary-500 lg:basis-auto">
                  <FontAwesomeIcon
                    :icon="faCircle"
                    class="fa-fw inline size-4"
                  />
                </span>
              </td>
              <td class="flex border align-middle lg:table-cell">
                <span class="te-school-col te-school-gray block basis-5/12 lg:hidden lg:basis-auto">
                  A社
                </span>
                <span class="te-school-col basis-7/12 lg:basis-auto">
                  <FontAwesomeIcon
                    :icon="faXmark"
                    class="fa-fw inline size-4"
                  />
                </span>
              </td>
              <td class="flex border align-middle lg:table-cell">
                <span class="te-school-col te-school-gray block basis-5/12 lg:hidden lg:basis-auto">
                  B社
                </span>
                <span class="te-school-col basis-7/12 lg:basis-auto">
                  <FontAwesomeIcon
                    :icon="faXmark"
                    class="fa-fw inline size-4"
                  />
                </span>
              </td>
            </tr>
            <tr
              v-if="originalAssignment"
              class="te-comparison-tr h-auto border lg:h-[100px]"
            >
              <th class="flex border align-middle lg:table-cell">
                <span class="te-school-heading inline lg:block">
                  <slot name="original">
                    オリジナルサービス
                    <br>
                    開発サポート
                  </slot>
                </span>
              </th>
              <td class="te-comparison-td flex border-8 border-y-0 border-co-primary-500 align-middle lg:table-cell">
                <span class="te-school-col block basis-5/12 bg-co-primary-500 text-white lg:hidden lg:basis-auto">
                  <img
                    class="mx-auto inline w-full"
                    src="~/assets/images/Te/TeCommon/Logo/logo.png"
                    alt="テックアカデミー"
                    style="max-width: 138px"
                  >
                </span>
                <span class="te-school-col co-display-11 block basis-7/12 text-co-primary-500 lg:basis-auto">
                  <FontAwesomeIcon
                    :icon="faCircle"
                    class="fa-fw inline size-4"
                  />
                </span>
              </td>
              <td class="flex border align-middle lg:table-cell">
                <span class="te-school-col te-school-gray block basis-5/12 lg:hidden lg:basis-auto">
                  A社
                </span>
                <span class="te-school-col block basis-7/12 lg:basis-auto">
                  <FontAwesomeIcon
                    :icon="faXmark"
                    class="fa-fw inline size-4"
                  />
                </span>
              </td>
              <td class="flex border align-middle lg:table-cell">
                <span class="te-school-col te-school-gray block basis-5/12 lg:hidden lg:basis-auto">
                  B社
                </span>
                <span class="te-school-col block basis-7/12 lg:basis-auto">
                  <FontAwesomeIcon
                    :icon="faXmark"
                    class="fa-fw inline size-4"
                  />
                </span>
              </td>
            </tr>
            <tr
              v-if="bannerguarantee"
              class="te-comparison-tr h-auto border lg:h-[100px]"
            >
              <th class="block border align-middle lg:table-cell">
                <span class="te-school-heading">
                  実案件の提供
                </span>
              </th>
              <td class="te-comparison-td flex border-8 border-y-0 border-co-primary-500 align-middle lg:table-cell">
                <span class="te-school-col block basis-5/12 bg-co-primary-500 text-white lg:hidden lg:basis-auto">
                  <img
                    class="mx-auto inline w-full"
                    src="~/assets/images/Te/TeCommon/Logo/logo.png"
                    alt="テックアカデミー"
                    style="max-width: 138px"
                  >
                </span>
                <span class="te-school-col co-display-11 basis-7/12 text-co-primary-500 lg:basis-auto">
                  <FontAwesomeIcon
                    :icon="faCircle"
                    class="fa-fw inline size-4"
                  />
                  <br>
                  3案件を確約
                </span>
              </td>
              <td class="flex border align-middle lg:table-cell">
                <span class="te-school-col te-school-gray block basis-5/12 lg:hidden lg:basis-auto">
                  A社
                </span>
                <span class="te-school-col block basis-7/12 lg:basis-auto">
                  <FontAwesomeIcon
                    :icon="faXmark"
                    class="fa-fw inline size-4"
                  />
                </span>
              </td>
              <td class="flex border align-middle lg:table-cell">
                <span class="te-school-col te-school-gray block basis-5/12 lg:hidden lg:basis-auto">
                  B社
                </span>
                <span class="te-school-col block basis-7/12 lg:basis-auto">
                  <FontAwesomeIcon
                    :icon="faXmark"
                    class="fa-fw inline size-4"
                  />
                </span>
              </td>
            </tr>
            <tr class="te-comparison-tr h-auto border lg:h-[100px]">
              <th class="block border align-middle lg:table-cell">
                <span class="te-school-heading">
                  転職サポート
                </span>
              </th>
              <td class="te-comparison-td flex border-8 border-t-0 border-co-primary-500 align-middle lg:table-cell">
                <span class="te-school-col block basis-5/12 bg-co-primary-500 text-white lg:hidden lg:basis-auto">
                  <img
                    class="mx-auto inline w-full"
                    src="~/assets/images/Te/TeCommon/Logo/logo.png"
                    alt="テックアカデミー"
                    style="max-width: 138px"
                  >
                </span>
                <span class="te-school-col co-display-11 block basis-7/12 text-co-primary-500 lg:basis-auto">
                  全コース対応
                </span>
              </td>
              <td class="flex border align-middle lg:table-cell">
                <span class="te-school-col te-school-gray block basis-5/12 lg:hidden lg:basis-auto">
                  A社
                </span>
                <span class="te-school-col block basis-7/12 lg:basis-auto">
                  一部コースのみ対応
                </span>
              </td>
              <td class="flex border align-middle lg:table-cell">
                <span class="te-school-col te-school-gray block basis-5/12 lg:hidden lg:basis-auto">
                  B社
                </span>
                <span class="te-school-col block basis-7/12 lg:basis-auto">
                  一部コースのみ対応
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faXmark } from '@awesome.me/kit-65d95819ce/icons/classic/solid'
import { faCircle } from '@awesome.me/kit-65d95819ce/icons/classic/regular'

const options = {
  async setup() {
    return {
      faXmark,
      faCircle,
    }
  },
  props: {
    originalAssignment: { // オリジナルの行を表示/非表示
      type: Boolean,
      default: false,
    },
    benefits: { // 給付金対象の行を表示/非表示
      type: Boolean,
      default: false,
    },
    bannerguarantee: { // 実案件の提供の行を表示/非表示
      type: Boolean,
      default: false,
    },
  },
  components: {
    FontAwesomeIcon,
  },
}

export default defineNuxtComponent(options)
</script>

<style scoped>
/* テーブルセルの背景色 */
.te-comparison-tr:nth-child(odd) {
  @media (min-width: 992px) {
    @apply bg-co-gray-100;
    .te-comparison-td {
      background: #f5fcff;
    }
  }
}

/* SP表示 */
@media (max-width: 991.98px) {
  .te-comparison-school-table tbody {
    th {
      padding: 1.25rem 0 0.5rem;
      border: none !important;
      .te-school-heading {
        display: block;
        width: 100%;
        padding-top: 0.25rem;
        padding-bottom: 0.25rem;
        font-size: 0.85rem;
        color: #4d4d4d;
      }
    }
    td {
      padding: 0;
      margin: 0;
      .te-school-col {
        padding: 0.5rem 1rem;
      }
      &:nth-child(2) {
        border: 3px solid #0b5770 !important;
      }
      &:nth-child(n + 3) {
        .te-school-col {
          &:nth-child(odd) {
            font-size: 0.75rem;
            font-weight: bold;
          }
          &:nth-child(even) {
            font-size: 0.75rem;
            color: #a1a1a1;
          }
        }
      }
      /* stylelint-disable-next-line */
      span:nth-child(2) {
      background-color: #fff;
      }
    }
  }
  .te-comparison-school-table .te-comparison-tr .te-comparison-td,
  .te-comparison-school-table
    .te-comparison-tr:nth-child(odd)
    .te-comparison-td {
    background: #0b5770 !important;
  }
  .te-school-gray {
    color: #fff;
    background: #a1a1a1;
  }
}
</style>
